import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/developers')({
  beforeLoad: ({ location }) => {
    throw redirect({ to: '/settings/api', hash: location.hash || undefined });
  },
});
